import { render } from "./ShiftSelection.vue?vue&type=template&id=728f3441&scoped=true"
import script from "./ShiftSelection.vue?vue&type=script&lang=js"
export * from "./ShiftSelection.vue?vue&type=script&lang=js"

import "./ShiftSelection.vue?vue&type=style&index=0&id=728f3441&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728f3441"]])

export default __exports__